import ApplicationController from './application_controller';
// Submits its form when the user selects a value from one of the form's <datalist>s.
//
// A plain <input list="..."> fires `change` when its value is committed — the user picked a
// suggestion from the dropdown, or left the field after changing it — so binding to `change`
// fires exactly "after a VLAN is selected", the moment the POP page's dialog should refresh its
// results in place. Enter and the explicit Trace button keep working natively; this only removes
// the extra click for the common case of picking a known value from the list.
//
// Only a value that actually appears as a datalist option submits. A number typed from scratch
// and then abandoned is a draft, not a selection: tracing it on blur would follow a VLAN the user
// never confirmed, so they press Enter or Trace for that.
//
// Declared on the FORM (data-controller), with the picker as its input target, so any form with a
// datalist picker gets the same behaviour — the POP topology page's in-page dialog and the
// standalone VLAN Path page's form both use it.
class default_1 extends ApplicationController {
    submitOnSelect() {
        if (!this.hasInputTarget)
            return;
        const input = this.inputTarget;
        const value = input.value.trim();
        if (value === '')
            return;
        const form = this.element;
        const options = form.querySelectorAll('datalist option');
        if (!Array.from(options).some((option) => option.value === value))
            return;
        form.requestSubmit();
    }
}
default_1.targets = ['input'];
export default default_1;
